// extracted by mini-css-extract-plugin
module.exports = {"single-personnel":"styles_single-personnel__R_c1k"};